/* eslint-disable */
// eslint-disable-next-line

var defaults = {
  title: "Default",
  description: "",
  items: [],
  attributes: [],
  audience: [],
};

export default {
  data() {
    return {
      item: {
        title: "",
        description: "",
        items: [],
        audience: "",
        attributes: [],
      },
      editMode: false,
      editIndex: null,
      deleteMode: false,
      newMode: true,
      deleteId: null,
      dialog: false,
    };
  },
  methods: {
    add() {
      this.item = defaults;
      this.editMode = false;
      this.newMode = true;
      this.dialog = true;
      console.log("Add");
      this.resetItem();
    },
    addItem() {
      let item = {
        index: this.items.length,
        ...this.item,
        id: this.items.length,
        type: "content",
      };
      this.exercise.doc.benefits.push(item);
      this.editMode = false;
      this.currId = null;
      this.currIndex = null;
      this.dialog = false;
      this.newMode = false;
      this.resetItem();
      this.saveDoc();
    },
    remove(index) {
      console.log("remove", index);
      this.deleteMode = true;
      this.newMode = false;
      this.deleteId = index;
      this.dialog = true;
    },
    removeItem() {
      this.exercise.doc.benefits.splice(this.deleteId, 1);
      this.cancel();
      this.saveDoc();
    },
    edit(index) {
      console.log("edit", index);
      this.editMode = true;
      this.newMode = false;
      this.dialog = true;
      this.editIndex = index;
      this.item = this.exercise.doc.benefits.find(
        (x) => x.id === this.editIndex
      );
    },
    editItem() {
      let item = {
        index: this.editIndex,
        ...this.item,
        id: this.editIndex,
        type: "content",
      };
      const indexOfItem = this.exercise.doc.benefits.indexOf(this.item);
      this.$set(this.exercise.doc.benefits, indexOfItem, item);
      this.editMode = false;
      this.currId = null;
      this.currIndex = null;
      this.newMode = false;
      this.dialog = false;
      this.resetItem();
      this.saveDoc();
    },
    cancel() {
      this.dialog = false;
      this.deleteId = null;
      this.deleteMode = false;
      this.newMode = false;
    },
    populateField(field) {
      return field ? field : "";
    },
    populateArray(field) {
      return field && field.length ? field : [];
    },
    resetItem() {
      this.item = {};
      this.$set(this.item, "items", []);
    },
    checkEditIndex(index) {
      if (this.editMode) {
        return index == this.editIndex ? false : true;
      } else {
        return false;
      }
    },
  },
};
